let contact = {
	init: function(){
		this.nav();
		contact.check();
	},
	nav: function(){
		$("input").off().on("change", function(){
			contact.check();
		});
		$("textarea").off().on("change", function(){
			contact.check();
		});
	},
	check: function(){
		let arry = [];
		$(".require").each(function(n){
			let $this = $(this);
			if( $this.find(`input[type="text"]`).length > 0 ){
				//console.log($this.find(`input[type="text"]`).length);
				for(var i = 0; i < $this.find(`input[type="text"]`).length; i++){
					let val = $this.find(`input[type="text"]:eq(${i})`).val();
					//console.log(val);
					if(val != ""){
						arry.push(1);
					}else{
						arry.push(0);
					}
				}
			}else if($this.find(`input[type="email"]`).length > 0){
				let val = $this.find(`input[type="email"]`).val();
				//console.log(val);
				if(val != ""){
					arry.push(1);
				}else{
					arry.push(0);
				}
			}else if( $this.find("select").length > 0 ){
				let val = $this.find("select option:selected").val();
				if(val != ""){
					arry.push(1);
				}else{
					arry.push(0);
				}
			}else if( $this.find("textarea").length > 0 ){
				let val = $this.find("textarea").val();
				if(val != ""){
					arry.push(1);
				}else{
					arry.push(0);
				}
			}
			
		});
		//console.log(arry, arry.indexOf(0));
		if( arry.indexOf(0) != -1 ){
			if( !$(`input[type="submit"]`).hasClass("disable") ){
				$(`input[type="submit"]`).addClass("disable");
				$(`.send input[type="submit"]`).off().on("click", function(){
					let category 	= "contact";
					let action 		= "send";
					let label 		= "contact";
					common.sendGa(category, action, label);
				});
			}
		}else{
			if( $(`input[type="submit"]`).hasClass("disable") ){
				$(`input[type="submit"]`).removeClass("disable");
			}
		}
	}
}